export default {
  props: {
    mt: String,
    mb: String,
    ml: String,
    mr: String
  },
  computed: {
    marginStyle () {
      return {
        marginTop: this.mt,
        marginBottom: this.mb,
        marginLeft: this.ml,
        marginRight: this.mr
      }
    }
  }
}
